import React from 'react';
import QualityAppSideNav from './QualityAppSideNav';
import { QualityProvider } from './context/QualityContext';
export const QualityAppContainer = () => {
  return <QualityProvider>
      <QualityAppSideNav />
    </QualityProvider>;
};